import { ContactDefinition } from "@/models/client-settings/ContactDefinition";

export class CompanyActivity {
  public isDisplay: boolean = true;
  constructor(public readonly contactDefinition: ContactDefinition) {}
}
